/**
 * @generated SignedSource<<30597a7d0c3a0287af9b9b9c8a4e1f60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AboTable_table$data = {
  readonly detailfilter: {
    readonly " $fragmentSpreads": FragmentRefs<"DetailFilter_detailFilter">;
  } | null | undefined;
  readonly documentheaders: {
    readonly all: boolean;
    readonly factsheet: boolean;
    readonly fpp: boolean;
    readonly generalpublications: boolean;
    readonly hjb: boolean;
    readonly info: boolean;
    readonly kid: boolean;
    readonly prospect: boolean;
    readonly publications: boolean;
    readonly rb: boolean;
    readonly taxtreat: boolean;
  } | null | undefined;
  readonly documentlabels: {
    readonly documentLabelsTitle: string | null | undefined;
    readonly labels: ReadonlyArray<{
      readonly key: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"OtherDocuments_documentLabels">;
  } | null | undefined;
  readonly entries: ReadonlyArray<{
    readonly category: string | null | undefined;
    readonly currency: string | null | undefined;
    readonly distribution: string | null | undefined;
    readonly documents: {
      readonly all: boolean;
      readonly factsheet: boolean;
      readonly fpp: boolean;
      readonly generalpublications: boolean;
      readonly hjb: boolean;
      readonly info: boolean;
      readonly kid: boolean;
      readonly prospect: boolean;
      readonly publications: boolean;
      readonly rb: boolean;
      readonly taxtreat: boolean;
    } | null | undefined;
    readonly fundsname: string | null | undefined;
    readonly id: string | null | undefined;
    readonly institutional: string | null | undefined;
    readonly isin: string | null | undefined;
    readonly salesadmission: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly traits: ReadonlyArray<string | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly filterbuttontext: string | null | undefined;
  readonly filterbuttontextexpanded: string | null | undefined;
  readonly languagepreference: {
    readonly currentselection: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"LanguagePreference_component">;
  } | null | undefined;
  readonly livefilter: {
    readonly " $fragmentSpreads": FragmentRefs<"LiveFilter_liveFilter">;
  } | null | undefined;
  readonly noResultsMessage: string | null | undefined;
  readonly subscriptionfilter: {
    readonly " $fragmentSpreads": FragmentRefs<"DetailFilter_detailFilter">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AboHeader_header">;
  readonly " $fragmentType": "AboTable_table";
};
export type AboTable_table$key = {
  readonly " $data"?: AboTable_table$data;
  readonly " $fragmentSpreads": FragmentRefs<"AboTable_table">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "all",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "kid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "factsheet",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publications",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rb",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hjb",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "taxtreat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fpp",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "info",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "prospect",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "generalpublications",
    "storageKey": null
  }
],
v1 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DetailFilter_detailFilter"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AboTable_table",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AboHeader_header"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentsSubscribed",
      "kind": "LinkedField",
      "name": "documentheaders",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SubscriptionTranche",
      "kind": "LinkedField",
      "name": "entries",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fundsname",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salesadmission",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "distribution",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "institutional",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "traits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DocumentsSubscribed",
          "kind": "LinkedField",
          "name": "documents",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentLabels",
      "kind": "LinkedField",
      "name": "documentlabels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DocumentLabel",
          "kind": "LinkedField",
          "name": "labels",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentLabelsTitle",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OtherDocuments_documentLabels"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveFilter",
      "kind": "LinkedField",
      "name": "livefilter",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LiveFilter_liveFilter"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailFilter",
      "kind": "LinkedField",
      "name": "detailfilter",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailFilter",
      "kind": "LinkedField",
      "name": "subscriptionfilter",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LanguagePreference",
      "kind": "LinkedField",
      "name": "languagepreference",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentselection",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LanguagePreference_component"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterbuttontext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterbuttontextexpanded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noResultsMessage",
      "storageKey": null
    }
  ],
  "type": "SubscriptionTable",
  "abstractKey": null
};
})();

(node as any).hash = "bb9c27b9e4aa107997a36665df4edfce";

export default node;
